import React, { useState } from 'react';
import ktima from './img/ktima.webp';
import Admin from './Admin';
import './App.css';

const STORAGE_KEY = 'wedding_rsvp_data';

// --- Translations Dictionary ---
const translations = {
  en: {
    couple: "Katerina & Kostas",
    titleOld: "Its not really a wedding",
    titleNew: "It will actually be a wedding",
    subtitleOld: "But the festivities will very much resemble one",
    subtitleNew: "And this will be a wedding too",
    koumparoi: "Best Men & Women",
    koumparoiList: ["Nikos & Marcelo", "Linos & Elektra"],
    when: "Schedule",
    preParty: "Friday 19/6 — Pre-Party at Karathona Beach at 16:00",
    prePartyNote: "Bring your swimsuit and towel!",
    schedule: [
      { time: "18:00–18:30", event: "Arrival" },
      { time: "19:00", event: "Wedding Ceremony" },
      { time: "20:00", event: "Dinner" },
      { time: "21:30", event: "Live Music" },
      { time: "2:00", event: "DJ" },
    ],
    where: "Where",
    accommodation: "Accommodation",
    accommodationText: "We recommend the following hotels for your stay:",
    accommodationRecommendations: [
      {
        label: "Kastraki Camping",
        link: "https://kastrakicamping.gr"
      },
      {
        label: "Pension Mariana",
        link: "https://www.hotelmarianna.gr"
      },
      {
        label: "Ktima Anastasia",
        link: "https://www.ktima-anastasia.gr",
      },
      {
        label: "Hotel Amalia",
        link: "https://www.amaliahotels.com/nafplio/hotel/",
      }
    ],
    hotelLink: "View Hotel Options",
    bankTitle: "Gift Registry",
    bankText: "If you'd like to gift us, you can use the following bank details:",
    bankIban: "GR8401404380438002340014476",
    bankName: "KONSTANTINOS PELELIS",
    bankBic: "CRBAGRAA",
    ibanLabel: "Account (IBAN)",
    beneficiaryLabel: "Beneficiary",
    bicLabel: "Bank Code (BIC)",
    bankToggle: "If you want to sponsor our next trip, click here",
    date: "June 20, 2026",
    addToCalendar: "📅 Add to Calendar",
    venueName: "Agroktima Elia, Nea Tirintha",
    rsvpTitle: "RSVP",
    firstName: "First Name",
    lastName: "Surname",
    willAttend: "Will you be attending?",
    yes: "Joyfully Accept",
    no: "Regretfully Decline",
    guestsLabel: "Total Number of People (including you)",
    guestNamesLabel: "Please list the names of other guests:",
    contactLabel: "Email or Phone (Optional)",
    sendButton: "Send RSVP",
    sending: "Sending...",
    success: "Thank you! Your RSVP has been saved.",
    error: "Something went wrong. Please try again.",
    duplicateError: "An RSVP with this name already exists.",
  },
  el: {
    couple: "Κατερίνα & Κώστας",
    titleOld: "Δεν ειναι καν γάμος",
    titleNew: "Θα ειναι τελικά γάμος",
    subtitleOld: "Αλλά το πάρτυ θα μοιάζει αρκετά",
    subtitleNew: "Και αυτό γάμος θα ειναι",
    koumparoi: "Κουμπάροι",
    koumparoiList: ["Νίκος & Marcelo", "Λίνος & Ηλέκτρα"],
    when: "Πρόγραμμα",
    preParty: "Παρασκευή 19/6 — Pre-Party στην παραλία Καραθώνα στις 16:00",
    prePartyNote: "Ελάτε με το μαγιώ και την πετσέτα σας!",
    schedule: [
      { time: "18:00–18:30", event: "Προσέλευση" },
      { time: "19:00", event: "Τελετή Γάμου" },
      { time: "20:00", event: "Φαγητό" },
      { time: "21:30", event: "Live μουσική" },
      { time: "2:00", event: "DJ" },
    ],
    where: "Τοποθεσία",
    accommodation: "Διαμονή",
    accommodationText: "Προτείνουμε τα παρακάτω ξενοδοχεία για τη διαμονή σας:",
    accommodationRecommendations: [
      {
        label: "Kastraki Camping",
        link: "https://kastrakicamping.gr"
      },
      {
        label: "Pension Mariana",
        link: "https://www.hotelmarianna.gr"
      },
      {
        label: "Κτήμα Anastasia",
        link: "https://www.ktima-anastasia.gr",
      },
      {
        label: "Ξενοδοχείο Amalia",
        link: "https://www.amaliahotels.com/nafplio/hotel/",
      }
    ],
    hotelLink: "Δείτε Επιλογές Ξενοδοχείων",
    bankTitle: "Δώρο",
    bankText: "Αν θέλετε να μας κάνετε δώρο, μπορείτε να χρησιμοποιήσετε τα παρακάτω στοιχεία:",
    bankIban: "GR8401404380438002340014476",
    bankName: "ΚΩΝΣΤΑΝΤΙΝΟΣ ΠΕΛΕΛΗΣ",
    bankBic: "CRBAGRAA",
    ibanLabel: "Λογαριασμός (IBAN)",
    beneficiaryLabel: "Δικαιούχος",
    bicLabel: "Κωδικός Τράπεζας (BIC)",
    bankToggle: "Αν θέλετε να χρηματοδοτήσετε το επόμενο ταξίδι μας, πατήστε εδώ",
    date: "Σάββατο 20 Ιουνίου 2026",
    addToCalendar: "📅 Προσθήκη στο Ημερολόγιο",
    venueName: "Κτήμα Ελιά, Νεα Τίρυνθα",
    rsvpTitle: "Δήλωση Παρουσίας",
    firstName: "Όνομα",
    lastName: "Επίθετο",
    willAttend: "Θα παρευρεθείτε;",
    yes: "Θα χαρώ να έρθω",
    no: "Δυστυχώς δεν μπορώ",
    guestsLabel: "Συνολικός Αριθμός Ατόμων (μαζί με εσάς)",
    guestNamesLabel: "Παρακαλώ γράψτε τα ονόματα των υπολοίπων:",
    contactLabel: "Email ή Τηλέφωνο (Προαιρετικό)",
    sendButton: "Αποστολή",
    sending: "Αποστολή...",
    success: "Ευχαριστούμε! Η δήλωσή σας αποθηκεύτηκε.",
    error: "Κάτι πήγε στραβά. Παρακαλώ προσπαθήστε ξανά.",
    duplicateError: "Υπάρχει ήδη δήλωση με αυτό το όνομα.",
  }
};

function App() {
  const [lang, setLang] = useState(() => {
    const browserLang = navigator.language || navigator.userLanguage; 
    return browserLang.startsWith('el') ? 'el' : 'en';
  });
  
  const t = translations[lang];
  const [formData, setFormData] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved ? JSON.parse(saved) : {
      firstName: '',
      lastName: '',
      attending: 'yes',
      guests: 1,
      guestNames: '', 
      contact: ''
    };
  });

  const [status, setStatus] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(() => {
    return !!localStorage.getItem(STORAGE_KEY);
  });
  const [isEditing, setIsEditing] = useState(false);
  const [showBank, setShowBank] = useState(false);

  if (window.location.pathname === '/admin') {
    return <Admin />;
  }

  const handleAddToCalendar = () => {
    const event = [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'PRODID:-//ICS Creator//EN',
      'BEGIN:VEVENT',
      'UID:kostas-katerina-not-wedding-20260620@icscreator',
      'DTSTAMP:20251214T000000Z',
      'SUMMARY:Kostas & Katerina',
      'DTSTART:20260620T160000Z',
      'DTEND:20260621T030000Z',
      'LOCATION:https://maps.app.goo.gl/MEaQaJJruoywHbKQ8',
      'DESCRIPTION:Not a wedding',
      'END:VEVENT',
      'END:VCALENDAR',
    ].join('\n');

    const blob = new Blob([event], { type: 'text/calendar;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'wedding.ics');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(t.sending);

    try {
      const payload = { ...formData, language: lang };
      const method = isEditing ? 'PUT' : 'POST';
      
      // Note: We use the relative path now because of the "proxy" in package.json
      const response = await fetch('/api/rsvp', {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        setIsSubmitted(true);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(formData));
        setStatus('');
      } else if (response.status === 409) {
        // Handle Duplicate Error
        setStatus(t.duplicateError);
      } else {
        setStatus(t.error);
      }
    } catch (error) {
      console.error(error);
      setStatus(t.error);
    }
  };

  const handleEdit = () => {
    setIsSubmitted(false); // Switch back to form mode (data is preserved in formData state)
    setIsEditing(true); // Flag that the next submit should be a PUT
  };

  return (
    <div className="container">
      {/* Language Toggle */}
      <div className="lang-switch">
        <button className={lang === 'el' ? 'active' : ''} onClick={() => setLang('el')}>🇬🇷 GR</button>
        <button className={lang === 'en' ? 'active' : ''} onClick={() => setLang('en')}>🇺🇸 EN</button>
      </div>

      <header>
        <h1>{t.couple}</h1>
        <h2><s>{t.titleOld}</s> {t.titleNew}</h2>
        <h3><s>{t.subtitleOld}</s> {t.subtitleNew}</h3>
        <div className="koumparoi">
          <h3>{t.koumparoi}</h3>
          {t.koumparoiList.map((name, idx) => (
            <p key={idx}>{name}</p>
          ))}
        </div>
      </header>

      {/* 1. Schedule */}
      <section className="card">
        <h2>{t.when}</h2>
        <p className="pre-party">{t.preParty}</p>
        <p className="pre-party-note">{t.prePartyNote}</p>
        <p><strong>{t.date}</strong></p>
        <div className="schedule-list">
          {t.schedule.map((item, idx) => (
            <div key={idx} className="schedule-item">
              <span className="schedule-time">{item.time}</span>
              <span className="schedule-event">{item.event}</span>
            </div>
          ))}
        </div>
        <button onClick={handleAddToCalendar}>{t.addToCalendar}</button>
      </section>

      {/* 2. Place */}
      <section className="card">
        <h2>{t.where}</h2>
        <a href="https://www.google.com/maps?client=safari&hs=NZyo&sca_esv=be6047ef5dda0c71&channel=mac_bm&uact=5&gs_lp=Egxnd3Mtd2l6LXNlcnAiD2Fncm9rdGltYSBlbGxpYTIVEC4YgAQYExjHARiYBRiZBRgNGK8BMgkQABiABBgTGA0yCBAAGBMYDRgeMgUQABjvBTIFEAAY7wUyBRAAGO8FMgUQABjvBTIFEAAY7wUyJBAuGIAEGBMYxwEYmAUYmQUYDRivARiXBRjcBBjeBBjgBNgBAUiKC1DdA1i3B3ABeAGQAQCYAYcBoAH9A6oBAzAuNLgBA8gBAPgBAZgCBKACmwPCAgoQABiwAxjWBBhHwgIIEAAYgAQYogSYAwDiAwUSATEgQIgGAZAGCLoGBggBEAEYFJIHAzEuM6AHgRmyBwMwLjO4B5gDwgcFMC4yLjLIBw6ACAA&um=1&ie=UTF-8&fb=1&gl=gr&sa=X&geocode=KZfw_zO-8J8UMX5WMUBmTFJv&daddr=Nea+Tiryntha+211+00" target="_blank" rel="noopener noreferrer">
          {t.venueName}
        </a>
        <img
          className="venue-img"
          src={ktima}
        />
      </section>

      {/* 3. Accommodation (New Section) */}
      <section className="card">
        <h2>{t.accommodation}</h2>
        <p>{t.accommodationText}</p>
        {/* Placeholder link - replace href with actual booking link */}
        {
          t.accommodationRecommendations.map((rec, idx) => (
            <a key={idx} href={rec.link} className="button-link">{rec.label}</a>
          ))
        }
      </section>

      {/* 4. RSVP Form */}
      <section className="card">
        <h2>{t.rsvpTitle}</h2>
        {!isSubmitted ? (
          // --- FORM VIEW ---
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div>
                  <label>{t.firstName} *</label>
                  <input required type="text" name="firstName" value={formData.firstName} onChange={handleChange} />
              </div>
              <div>
                  <label>{t.lastName} *</label>
                  <input required type="text" name="lastName" value={formData.lastName} onChange={handleChange} />
              </div>
            </div>

            <label>{t.willAttend}</label>
            <select name="attending" value={formData.attending} onChange={handleChange}>
              <option value="yes">{t.yes}</option>
              <option value="no">{t.no}</option>
            </select>

            {formData.attending === 'yes' && (
              <>
                <label>{t.guestsLabel}</label>
                <input 
                  type="number" 
                  name="guests" 
                  min="1" 
                  value={formData.guests} 
                  onChange={handleChange} 
                />
                
                <label>{t.guestNamesLabel}</label>
                <textarea 
                  name="guestNames" 
                  rows="3"
                  value={formData.guestNames} 
                  onChange={handleChange} 
                />
              </>
            )}

            <label>{t.contactLabel}</label>
            <input 
              type="text" 
              name="contact" 
              value={formData.contact} 
              onChange={handleChange} 
            />

            <button type="submit">{t.sendButton}</button>
            {status && <p style={{ marginTop: '1rem', color: 'red' }}>{status}</p>}
          </form>
        ) : (
          // --- SUMMARY / EDIT VIEW ---
          <div className="summary-view">
             <div style={{ color: 'var(--earth-brown)', marginBottom: '20px' }}>
                <h3 style={{fontSize: '1.5rem'}}>✓ {t.successTitle}</h3>
                <p>{t.successMessage}</p>
             </div>
             
             <div style={{ textAlign: 'left', background: '#fff', padding: '15px', borderRadius: '8px', border: '1px solid var(--wheat-primary)' }}>
                <p><strong>{t.firstName}:</strong> {formData.firstName} {formData.lastName}</p>
                <p><strong>Response:</strong> {formData.attending === 'yes' ? t.yes : t.no}</p>
                {formData.attending === 'yes' && (
                    <p><strong>{t.guestsLabel}:</strong> {formData.guests}</p>
                )}
             </div>

             <button 
                onClick={handleEdit} 
                style={{ backgroundColor: 'transparent', color: 'var(--earth-brown)', border: '1px solid var(--earth-brown)', marginTop: '20px' }}
             >
               ✏️ {t.editButton}
             </button>
          </div>
        )}
      </section>

      {/* 5. Bank Details */}
      <section className="card bank-details">
        <p className="bank-toggle" onClick={() => setShowBank(!showBank)}>{t.bankToggle}</p>
        {showBank && (
          <>
            <p className="bank-label">{t.ibanLabel}</p>
            <p className="bank-value">{t.bankIban}</p>
            <p className="bank-label">{t.beneficiaryLabel}</p>
            <p className="bank-value">{t.bankName}</p>
            <p className="bank-label">{t.bicLabel}</p>
            <p className="bank-value">{t.bankBic}</p>
          </>
        )}
      </section>
    </div>
  );
}

export default App;
